import DonnonsLogo from '@/core/components/DonnonsLogo/DonnonsLogo';

export default DonnonsLogo;
